import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslationService } from '../../../../shared/translations/services/translation.service';
import { DateFormatService } from '../../../../shared/services/date-format.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-accessibility-statement',
  templateUrl: './accessibility-statement.component.html',
  styleUrls: ['./accessibility-statement.component.scss'],
  standalone: false
})
export class AccessibilityStatementComponent implements OnInit, OnDestroy {
  translationService = inject(TranslationService);
  dateFormatService = inject(DateFormatService);

  readonly PUBLISH_DATE = '09/24/2026';

  appUrl: string;
  formattedPublishDate: string;

  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.appUrl = environment.appHome || '';
    this.formattedPublishDate = this.formatDate(this.PUBLISH_DATE, this.dateFormatService.currentFormat);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Pure date-reformatting function.
   * Input: rawDate always in 'MM/DD/YYYY' canonical form.
   * Output: reformatted string matching the requested format.
   * Defaults to MM/DD/YYYY for any unrecognised format string.
   */
  formatDate(rawDate: string, format: string): string {
    const [month, day, year] = rawDate.split('/');
    if (format === 'DD/MM/YYYY') return `${day}/${month}/${year}`;
    return rawDate; // MM/DD/YYYY is both the canonical form and the default
  }

  protected readonly environment = environment;
}
